var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 5.30769H4.33333M7 5.30769H7.66667M10.3333 5.30769H11M13.6667 5.30769H14.3333M9.66667 12.6923V8.38462M11.6667 12.6923L11.6667 10.2308M3 16.0769C3 16.5865 3.448 17 4 17H6.68978C6.92353 16.6252 7.26016 16.3139 7.66573 16.0975C8.07131 15.8811 8.53152 15.7671 9 15.7671C9.46848 15.7671 9.92869 15.8811 10.3343 16.0975C10.7398 16.3139 11.0765 16.6252 11.3102 17H14C14.552 17 15 16.5865 15 16.0769L15 1.92308C15 1.41354 14.552 1 14 1H11.3102C11.0765 1.37477 10.7398 1.68605 10.3343 1.9025C9.92869 2.11894 9.46848 2.23291 9 2.23291C8.53152 2.23291 8.07131 2.11894 7.66573 1.9025C7.26016 1.68605 6.92353 1.37477 6.68978 1H4C3.448 1 3 1.41354 3 1.92308L3 16.0769Z",
    stroke: "#435869",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTicket);
export default __webpack_public_path__ + "static/media/icTicket.46db8c2cd22afdbdb4149e1a8e1e4971.svg";
export { ForwardRef as ReactComponent };